import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { QBClass } from '../../../../../data/qb-class';

@Component({
    selector: 'app-sale-list-chooser',
    templateUrl: './sale-list-chooser.component.html',
    styleUrls: ['./sale-list-chooser.component.scss']
})
export class SaleListChooserComponent implements OnInit {
    items: QBClass[];

    constructor(
        private dialog: MatDialog,
        @Inject(MAT_DIALOG_DATA) public data: [],
        protected dialogRef: MatDialogRef<SaleListChooserComponent>) { }

    ngOnInit(): void {
        this.items = this.data
    }

    cancelButton() {
        this.dialogRef.close(null)
    }

    chooseItem(item: QBClass) {
        this.dialogRef.close(item)
    }

}
